import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppNotifyService } from './notify.service';
import { AppNotifyComponent } from './notify.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FlexModule } from '@angular/flex-layout';

@NgModule({
  declarations: [AppNotifyComponent],
  imports: [
    CommonModule,
    FlexModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
  providers: [AppNotifyService],
})
export class AppNotifyModule {}
